var map = {
	"./admin_settings.png": 1757,
	"./appraisals.png": 1758,
	"./catalog.png": 1759,
	"./catalogWhite.png": 1760,
	"./catalog_orders.png": 1761,
	"./cms.png": 1762,
	"./component-fields/Asset.png": 1763,
	"./component-fields/Blocks.png": 1764,
	"./component-fields/Boolean.png": 1765,
	"./component-fields/Date-time.png": 1766,
	"./component-fields/LInk.png": 1767,
	"./component-fields/Markdown.png": 1768,
	"./component-fields/Multi asset.png": 1769,
	"./component-fields/Multi options.png": 1770,
	"./component-fields/Number.png": 1771,
	"./component-fields/Richtext.png": 1772,
	"./component-fields/Single options.png": 1773,
	"./component-fields/Table.png": 1774,
	"./component-fields/Text area.png": 1775,
	"./component-fields/Text.png": 1776,
	"./components.png": 1777,
	"./configuration.png": 1778,
	"./contents.png": 1779,
	"./crm.png": 1780,
	"./custom_order.png": 1781,
	"./customer_credits.png": 1782,
	"./customer_list.png": 1783,
	"./dashboard.png": 1784,
	"./finance.png": 1785,
	"./home.png": 1786,
	"./integrations.png": 1787,
	"./inventory-transfers.png": 1788,
	"./invoice-list.png": 1789,
	"./layaway.png": 1790,
	"./move.png": 1791,
	"./new_sale.png": 1792,
	"./orders.png": 1793,
	"./outgoing-consignments.png": 1794,
	"./payment-methods/amex.png": 1175,
	"./payment-methods/discover.png": 1174,
	"./payment-methods/mastercard.png": 1173,
	"./payment-methods/visa.png": 1172,
	"./payments.png": 1795,
	"./plus.png": 1380,
	"./register.png": 1796,
	"./repair_center.png": 1797,
	"./reports.png": 1798,
	"./services.png": 1799,
	"./trade_in_center.png": 1800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1630;